import React from 'react'
import { useShallow } from 'zustand/react/shallow'

import { useNavigationStore } from '../state/navigationStore'

const Overlay = () => {
  const {
    filterPanelOpen,
    setFilterPanelOpen,
    wizardOpen,
    setWizardOpen,
    screen,
    systemModalOpen,
    setSystemModalOpen,
    caseModalOpen,
    setCaseModalOpen,
  } = useNavigationStore(
    useShallow((state) => ({
      filterPanelOpen: state.filterPanelOpen,
      setFilterPanelOpen: state.setFilterPanelOpen,
      wizardOpen: state.wizardOpen,
      setWizardOpen: state.setWizardOpen,
      screen: state.screen,
      systemModalOpen: state.systemModalOpen,
      setSystemModalOpen: state.setSystemModalOpen,
      caseModalOpen: state.caseModalOpen,
      setCaseModalOpen: state.setCaseModalOpen,
    }))
  )

  const isActive =
    filterPanelOpen ||
    (wizardOpen && screen === 'list') ||
    systemModalOpen ||
    caseModalOpen

  return (
    <div
      className={['overlay', isActive && 'overlay--active'].join(' ')}
      onClick={() => {
        if (filterPanelOpen) {
          setFilterPanelOpen(false)
        }

        if (wizardOpen) {
          setWizardOpen(false)
        }

        if (systemModalOpen) {
          setSystemModalOpen(false)
        }

        if (caseModalOpen) {
          setCaseModalOpen(false)
        }
      }}
    ></div>
  )
}

export { Overlay }
